import {
  ExtranetCatalogItemChevron,
  ExtranetContainer,
  ExtranetExpandArrowColumn,
  ExtranetTable,
  ExtranetTableColumn,
  ExtranetTableRow,
  formatDateString,
  useBreakpoint,
  useLanguage,
} from '@pharmac-extranet/shared'
import { PharmacTableColumn, PharmacText } from '@pharmac/ui'
import { useQuery } from '@tanstack/react-query'
import { useCustomerContext } from '../../features/customer/CustomerProvider'
import { api } from '../../services/HttpService'
import { OrderTicketOutOfStockProductsMobileView } from './OrderTicketOutOfStockProductsMobileView'
import { OrderTicketOutOfStockProductsTable } from './OrderTicketOutOfStockProductsTable'

type Props = {
  ticket: any
  requestChecked?: boolean
}

export const OrderTicketCustomersTable = ({ ticket, requestChecked }: Props) => {
  const { minDesktop } = useBreakpoint()
  const { t } = useLanguage()
  const { customer } = useCustomerContext()

  const params = {
    customerGroupId: ticket.customerGroupId,
    deadlineDate: ticket.deadlineDate,
    deadlineTime: ticket.deadlineTime,
    active: !requestChecked,
  }

  const { data: orderTickets } = useQuery({
    queryFn: async () => await api.orders.getOrderTicketsByGroup(customer!.id as number, params),
    queryKey: ['__getCustomerGroupOrderTickets', customer?.id, ticket.customerGroupId, params],
    enabled: typeof customer?.id === 'number',
  })

  return (
    <ExtranetTable>
      {minDesktop && (
        <ExtranetTableRow
          noBorders
          noMargin
          style={{
            backgroundColor: 'var(--extranet-light-purple)',
            border: 'none',
            fontWeight: 600,
          }}
        >
          <ExtranetTableColumn
            size={6}
            marginSmallLeft
          >
            {t('common:name')}
          </ExtranetTableColumn>
          <ExtranetTableColumn size={3}>
            {t('extranet:orderHistory.dateOfBirth')}
          </ExtranetTableColumn>
          <ExtranetTableColumn size={3}>
            {t('extranet:orderHistory.orderNumber')}
          </ExtranetTableColumn>
          <ExtranetTableColumn size={3}>
            {t('extranet:orderHistory.subscriptionPeriod')}
          </ExtranetTableColumn>
          <ExtranetExpandArrowColumn />
        </ExtranetTableRow>
      )}

      {orderTickets?.map((a) => (
        <ExtranetTableRow
          noBorders
          noMargin
          style={{
            borderTop: minDesktop ? '2px solid var(--color-accent-4)' : undefined,
            borderBottom: minDesktop ? undefined : '2px solid var(--color-accent-4)',
          }}
          key={a.id}
          expand={
            minDesktop ? (
              <OrderTicketOutOfStockProductsTable
                requestChecked={requestChecked}
                ticketId={a.id}
              />
            ) : (
              <OrderTicketOutOfStockProductsMobileView
                ticket={a}
                requestChecked={requestChecked}
              />
            )
          }
          toggleExpand={() => null}
          children={({ isExpanded }) => (
            <>
              <PharmacTableColumn size={6}>
                <ExtranetContainer marginSmallLeft>
                  <PharmacText>{a.wholeName}</PharmacText>
                </ExtranetContainer>
              </PharmacTableColumn>
              {minDesktop && (
                <PharmacTableColumn size={3}>
                  <ExtranetContainer alignCenter>
                    <PharmacText>{formatDateString(a.birthDate)}</PharmacText>
                  </ExtranetContainer>
                </PharmacTableColumn>
              )}
              {minDesktop && (
                <PharmacTableColumn size={3}>
                  <PharmacText>{a.orderId}</PharmacText>
                </PharmacTableColumn>
              )}
              {minDesktop && (
                <PharmacTableColumn size={3}>
                  <PharmacText>
                    {formatDateString(a.startDate)} - {formatDateString(a.endDate)}
                  </PharmacText>
                </PharmacTableColumn>
              )}
              <ExtranetExpandArrowColumn>
                <ExtranetCatalogItemChevron isExpanded={isExpanded} />
              </ExtranetExpandArrowColumn>
            </>
          )}
        />
      ))}
    </ExtranetTable>
  )
}
